import { Typography } from '@mui/material';
import { Container } from '@mui/system';
import React from 'react';
import styled from 'styled-components';

const WinnersContainer = styled.section`
  padding: 2.5rem 0;
`;

export const Winners = () => {
  return (
    <WinnersContainer>
      <Container>
        <Typography
          variant='h5'
          align='center'
          className='white--text'
          gutterBottom
        >
          Ganhadores
        </Typography>
        <Typography
          variant='body1'
          align='center'
          className='white--text'
        >
          Promoção em andamento.<br/>
          ainda dá tempo de participar, aproveite!
        </Typography>
      </Container>
    </WinnersContainer>
  )
}
